// React
import React from 'react'
import validator from 'validator'
// GraphQL
import { compose, graphql } from 'react-apollo'
// GraphQL mutations
import { nameUpdateMutation } from '../../graphql/mutations/user'
import { emailUpdateMutation, passwordUpdateMutation, accountDeleteMutation } from '../../graphql/mutations/account'
// Components
import BackButton from '../Nav/BackButton'
import Button from '../Display/Button'
import ConsciousApps from '../Footer/ConsciousApps'
import Input from '../Display/Input'
import Loading from '../Display/Loading'
import Modal from '../Display/Modal'
import Toggle from '../Display/Toggle'

class Settings extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			id: '',
			nameFirst: '',
			nameLast: '',
			email: '',
			toggleView: 'email',
			newEmail: '',
			password: '',
			oldPassword: '',
			newPassword: '',
			newPasswordConfirm: '',
			deletePassword: '',
			message: { text: '', color: '#333' },
			loading: { status: false, text: '' },
			modal: { status: 'hidden', title: '', text: '', action: { text: '', func: () => (null) }, cancel: { text: '', func: () => (null) }, loading: false }
		}
	}

	componentWillMount() {
		if (this.props.user) {
			this.setState({
				id: this.props.user.id,
				nameFirst: this.props.user.nameFirst,
				nameLast: this.props.user.nameLast,
				email: this.props.user.email
			})
		}
	}

	componentDidMount() { window.scrollTo(0, 0) }


	// FUNCTIONS
	updateName = () => {
		const { id, nameFirst, nameLast } = this.state
		this.setState({ loading: { status: true, text: 'Updating name...' } })
		this.props.nameUpdate({ variables: { userId: id, nameFirst, nameLast } })
			.then(() => {
				this.setState({
					loading: { status: false, text: '' },
					modal: {
						status: 'visible',
						title: 'Name updated',
						text: 'Your name has been successfully updated to ' + nameFirst + ' ' + nameLast + '.',
						action: {
							text: 'Ok',
							func: () => {
								this.props.refetch()
								this.closeModal()
							}
						},
						cancel: {
							text: '',
							func: () => (null)
						},
						loading: false
					}
				})
			})
			.catch((err) => this.errorMessage(err))
	}

	updateEmail = () => {
		const { email, newEmail, password } = this.state
		this.setState({ loading: { status: true, text: 'Updating email...' } })
		this.props.emailUpdate({ variables: { email, password, newEmail } })
			.then(() => {
				const updateLogin = () => {
					this.setState({
						email: newEmail,
						newEmail: '',
						password: '',
						loading: { status: false, text: '' },
						message: { text: '', color: '#333' },
						modal: {
							status: 'visible',
							title: 'Email updated',
							text: 'Your email has been updated to ' + newEmail + '. Please check your email and click the confirmation link inside the email to confirm your account.',
							action: {
								text: 'Ok',
								func: () => {
									this.props.refetch()
									this.closeModal()
								}
							},
							cancel: {
								text: '',
								func: () => (null)
							},
							loading: false
						}
					})
				}
				// If on web, ask to save login data
				if (process.env.REACT_APP_ENV === 'web') {
					this.setState({
						modal: {
							status: 'visible',
							title: 'Save email for quick login?',
							text: 'Select ‘no’ if you’re on a public computer or are using another person’s mobile device. Your email will be updated regardless.',
							action: {
								text: 'Yes',
								func: () => {
									window.localStorage.setItem('MoonSignApp:email', newEmail)
									updateLogin()
								}
							},
							cancel: {
								text: 'No',
								func: () => {
									window.localStorage.removeItem('MoonSignApp:email')
									updateLogin()
								}
							},
							loading: false
						}
					})
				}
				// If on devices like iOS, Android, or macOS, always save email
				else {
					window.localStorage.setItem('MoonSignApp:email', newEmail)
					updateLogin()
				}
			})
			.catch((err) => this.errorMessage(err))
	}

	updatePassword = () => {
		const { email, oldPassword, newPassword } = this.state
		this.setState({ loading: { status: true, text: 'Updating password...' } })
		this.props.passwordUpdate({ variables: { email, oldPassword, newPassword } })
			.then(() => {
				this.setState({
					loading: { status: false, text: '' },
					oldPassword: '',
					newPassword: '',
					newPasswordConfirm: '',
					modal: {
						status: 'visible',
						title: 'Password updated',
						text: 'Your password has been updated.',
						action: {
							text: 'Continue',
							func: () => this.closeModal()
						},
						cancel: {
							text: '',
							func: () => (null)
						},
						loading: false
					}
				})
			})
			.catch((err) => this.errorMessage(err))
	}

	deleteAccount = () => {
		const proceed = () => {
			const { email, deletePassword } = this.state
			this.setState({ loading: { status: true, text: 'Deleting account...' } })
			this.props.accountDelete({ variables: { email, password: deletePassword } })
				.then(() => {
					this.setState({
						deletePassword: '',
						loading: { status: false, text: '' },
						modal: {
							status: 'visible',
							title: 'Account deleted',
							text: 'Your account has been deleted.',
							action: { text: 'Ok', func: () => {
								window.localStorage.removeItem('MoonSignApp:email')
								this.props.redux.auth.logoutUser()
							} },
							cancel: { text: '', func: () => (null) },
							loading: false
						}
					})
				})
				.catch((err) => this.errorMessage(err))
		}
		this.setState({
			modal: {
				status: 'visible',
				title: 'Delete account?',
				text: 'Your account will be permanently deleted.',
				action: { text: 'Yes', func: () => {
					this.closeModal()
					proceed()
				} },
				cancel: { text: 'No', func: () => this.closeModal() },
				loading: false
			}
		})
	}

	errorMessage = (err) => {
		const errorMessage = err.toString().split(':')
		this.setState({
			loading: { status: false, text: '' },
			modal: {
				status: 'visible',
				title: 'Error',
				text: errorMessage[errorMessage.length-1].substr(1),
				action: {
					text: 'Continue',
					func: () => this.closeModal()
				},
				cancel: {
					text: '',
					func: () => (null)
				},
				loading: false
			}
		})
	}


	// VALIDATION
	validation = (category) => {
		const { nameFirst, nameLast, email, newEmail, password, oldPassword, newPassword, newPasswordConfirm, deletePassword } = this.state
		switch (category) {
		case 'name':			return (
			nameFirst.length > 1
			&& nameLast.length > 1
			&& (this.props.user.nameFirst !== nameFirst || this.props.user.nameLast !== nameLast)
		)
		case 'email':			return email !== newEmail && validator.isEmail(newEmail) && password.length >= 6
		case 'password':	return newPassword.length >= 6 && oldPassword !== newPassword && newPassword === newPasswordConfirm
		case 'delete':		return deletePassword.length >= 6
		default:					return false
		}
	}


	// MODAL
	closeModal = () => this.setState({ modal: { status: 'hidden', title: '', text: '', action: { text: '', func: () => null }, cancel: { text: '', func: () => null } } })


	// INPUT HANDLERS
	handleInput = (name, value) => {
		let { email, newEmail, password, oldPassword, newPassword, newPasswordConfirm } = this.state
		this.setState({ [name]: value })
		switch (name) {
		case 'newEmail':						newEmail = value; break
		case 'password':						password = value; break
		case 'oldPassword':					oldPassword = value; break
		case 'newPassword':					newPassword = value; break
		case 'newPasswordConfirm':	newPasswordConfirm = value; break
		default:										newEmail = value
		}
		// Create messages to user
		// Update email
		if (name === 'newEmail') {
			if (newEmail === '') {
				this.setState({ message: { text: '', color: '#333' } })
			}
			else if (newEmail === email) {
				this.setState({ message: { text: 'Email is the same', color: '#FF0000' } })
			}
			else {
				this.setState({
					message: {
						text: validator.isEmail(newEmail) ? 'Valid email' : 'Invalid email',
						color: validator.isEmail(newEmail) ? '#008000' : '#FF0000'
					}
				})
			}
		}
		else if (name === 'password') {
			if (password.length > 0 && password.length < 6) {
				this.setState({ message: { text: 'Password has to be at least 6 characters', color: '#FF0000' } })
			}
			else {
				this.setState({ message: { text: '', color: '#333' } })
			}
		}
		// Update password input
		else if (name === 'oldPassword' || name === 'newPassword' || name === 'newPasswordConfirm') {
			if (
				newPassword.length > 0 && newPasswordConfirm.length > 0 && newPassword !== newPasswordConfirm
			) {
				this.setState({ message: { text: 'Password does not match', color: '#FF0000' } })
			}
			else if (
				(newPassword.length > 0 && newPassword.length < 6)
				|| (newPasswordConfirm.length > 0 && newPasswordConfirm.length < 6)
			) {
				this.setState({ message: { text: 'New password has to be at least 6 characters', color: '#FF0000' } })
			}
			else if (
				((oldPassword.length > 0 || newPassword.length > 0) && oldPassword === newPassword)
				|| ((oldPassword.length > 0 || newPasswordConfirm.length > 0) && oldPassword === newPasswordConfirm)
			) {
				this.setState({ message: { text: 'Current and new password are the same', color: '#FF0000' } })
			}
			else if (newPassword.length > 0 && newPassword === newPasswordConfirm) {
				this.setState({ message: { text: 'Password confirmed', color: '#008000' } })
			}
			else {
				this.setState({ message: { text: '', color: '#333' } })
			}
		}
	}

	handleToggle = (source, data) => {
		this.setState({ [source]: data, message: { text: '', color: '#333' } })
	}


	render() {
		const { nameFirst, nameLast, email, loading, message, modal, toggleView, newEmail, password, oldPassword, newPassword, newPasswordConfirm, deletePassword } = this.state
		return (
			<div className='capps-container'>
				<BackButton {...this.props} />
				<Loading status={loading.status} text={loading.text} />
				<Modal
					status={modal.status}
					title={modal.title}
					text={modal.text}
					action={{ text: modal.action.text, func: modal.action.func }}
					cancel={{ text: modal.cancel.text, func: modal.cancel.func }}
					loading={modal.loading}
				/>
				<div className='capps-height-10' />
				<div className='capps-header'>Settings</div>

				{/* IN-APP PURCHASE */}
				{!this.props.user.accountPaid &&
					<div>
						<div className='capps-height-10' />
						<Button
							action={() => this.props.redux.nav.setPage('upgrade')}
							text='Get Complete Access'
						/>
					</div>
				}

				{/* NAME */}
				<div className='capps-flex-horiz-center'>
					<Input
						label='First name'
						name='nameFirst'
						onChange={(name, value) => this.handleInput(name, value)}
						onKeyPress={this.handleKeyPress}
						style={{ marginBottom: '0px' }}
						type='text'
						value={nameFirst}
					/>
					<Input
						label='Last name'
						name='nameLast'
						onChange={(name, value) => this.handleInput(name, value)}
						onKeyPress={this.handleKeyPress}
						style={{ marginBottom: '0px' }}
						type='text'
						value={nameLast}
					/>
				</div>
				<Button
					action={this.validation('name') ? () => this.updateName() : null}
					flat={!this.validation('name')}
					text='Update name'
				/>

				{/* TOGGLE */}
				<div className='capps-height-20' />
				<Toggle name='toggleView' status={toggleView} onDataChange={this.handleToggle} label1='email' label2='password' />
				{/* UPDATE EMAIL */}
				{toggleView === 'email' &&
					<div>
						<Input
							label='New email'
							name='newEmail'
							onChange={(name, value) => this.handleInput(name, value)}
							tab={true}
							type='email'
							value={newEmail}
						/>
						<Input
							label='Current password'
							name='password'
							onChange={(name, value) => this.handleInput(name, value)}
							tab={true}
							type='password'
							value={password}
						/>
						<Button
							action={this.validation('email') ? () => this.updateEmail() : null}
							flat={!this.validation('email')}
							text='Update email'
						/>
						{message.text === ''
							?
								<div className='capps-footer'><center>Current email: <span className='capps-link'>{email}</span></center></div>
							:
								<div className='capps-footer' style={{ color: message.color, fontWeight: '400' }}><center>{message.text}</center></div>
						}
					</div>
				}

				{/* UPDATE PASSWORD */}
				{toggleView === 'password' &&
					<div>
						<Input
							label='Current password'
							name='oldPassword'
							onChange={(name, value) => this.handleInput(name, value)}
							tab={true}
							type='password'
							value={oldPassword}
						/>
						<Input
							label='New password'
							name='newPassword'
							onChange={(name, value) => this.handleInput(name, value)}
							tab={true}
							type='password'
							value={newPassword}
						/>
						<Input
							label='New password (verify)'
							name='newPasswordConfirm'
							onChange={(name, value) => this.handleInput(name, value)}
							tab={true}
							type='password'
							value={newPasswordConfirm}
						/>
						<Button
							action={this.validation('password') ? () => this.updatePassword() : null}
							flat={!this.validation('password')}
							text='Update password'
						/>
						{message.text === ''
							?
								<div className='capps-footer'>
									<span onTouchTap={() => {
										this.props.redux.auth.logoutUser()
										window.location.reload()
										window.history.pushState('', '', '/reset')
										this.props.redux.nav.setPage('')
									}} className='capps-link'>Reset your password</span>
								</div>
							:
								<div className='capps-footer' style={{ color: message.color, fontWeight: '400' }}><center>{message.text}</center></div>
						}
					</div>
				}

				{/* DELETE ACCOUNT */}
				<Input
					label='Password'
					name='deletePassword'
					onChange={(name, value) => this.handleInput(name, value)}
					tab={true}
					type='password'
					value={deletePassword}
				/>
				<Button
					action={this.validation('delete') ? () => this.deleteAccount() : null}
					alert={this.validation('delete')}
					flat={!this.validation('delete')}
					text='Delete account'
				/>

				{/* VERSION */}
				<div className='capps-height-20' />
				<div className='capps-footer'>Moon Sign App v{process.env.REACT_APP_VERSION}</div>

				{/* SUPPORT */}
				<ConsciousApps {...this.props} />
			</div>
		)
	}
}


export default compose(
	graphql(nameUpdateMutation, { name: 'nameUpdate' }),
	graphql(emailUpdateMutation, { name: 'emailUpdate' }),
	graphql(passwordUpdateMutation, { name: 'passwordUpdate' }),
	graphql(accountDeleteMutation, { name: 'accountDelete' })
)(Settings)



// WEBPACK FOOTER //
// ./src/Components/Settings/Settings.js